<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <b-row>
                    <b-col cols="12" class="admin-topbar">
                        <h2 class="admin-topbar-title">{{ layout[0].name }}</h2>
                        <div style="display:flex; flex-direction:row">
                            <select
                                class="admin-select-network"
                                @change="switchNetwork($event)"
                            >
                                <option
                                    :value="item.value"
                                    v-bind:selected="item.value == chainId"
                                    v-for="(item, a) in getAllNetwork"
                                    :key="a"
                                >
                                    {{ item.name }}
                                </option>
                            </select>
                            <AdminConnectWallet></AdminConnectWallet>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import AdminConnectWallet from "./Button/AdminConnectWallet.vue";

export default {
    components: {
        AdminConnectWallet
    },
    computed: {
        ...mapGetters({
            getAllNetwork: "vaults/getAllNetwork",
            chainId: "wallet/getChainId"
        }),
        layout() {
            return this.$route.meta.breadcrumb;
        }
    },
    mounted() {},
    methods: {
        async changeChain(chainId) {
            await this.$store.dispatch("wallet/chainChanged", chainId);
        },
        async switchNetwork(event) {
            try {
                await ethereum
                    .request({
                        method: "wallet_switchEthereumChain",
                        params: [{ chainId: event.target.value }]
                    })
                    .then(result => {
                        this.changeChain(event.target.value);
                    });
            } catch (addError) {
                this.$refs["network-alert"].show();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.admin-topbar {
    border: 1px solid #eaedf0;
    margin-bottom: 1.2847222222222223vw;
    // padding: 1.8055555556vw 1.0416666666666667vw;
    padding: 20px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .admin-topbar-title {
        font-family: "Exo";
        color: #000000;
        font-style: normal;
        font-weight: bold;
        // font-size: 1.3888888888888888vw;
        line-height: 1.875vw;
        text-transform: uppercase;
    }
}
.admin-header-container {
    position: relative;
    height: 70px;
    width: 100%;
}

.admin-header {
    position: absolute;
    z-index: 1;
    border-bottom: 1px solid rgba(234, 237, 240, 1);
    width: 120%;
    left: -20px;
    padding: 0 0 20px 40px;
    font-weight: bold;
    font-size: 20px;
    text-transform: uppercase;
}

.admin-select-network {
    border: none;
    border-radius: 20px;
    background: #27ae60;
    color: white;
    font-weight: 800;
    width: 100px;
    padding: 0px 10px;
    text-transform: uppercase;
}
</style>
